<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link
                    :to="
                      $route.path.includes('selling')
                        ? `/selling/hourly-chauffeur`
                        : `/buying/hourly-chauffeur`
                    "
                  >
                    {{
                      $route.path.includes("selling") ? "Booker" : "Operator"
                    }}
                    Tariff
                  </router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  {{ rentalLabel }} &hyphen; Chauffeur Rate
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate && userType !== 'ProviderUser'"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div
                  class="pull-left"
                  :class="{
                    'pl-30': userType !== 'ProviderUser',
                  }"
                >
                  <h2>
                    {{ rentalLabel }} &hyphen; Chauffeur Rate ({{ className }})
                    <span><i class="ic-price-calculator"></i></span>
                  </h2>
                  <p>Set all rental rate.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6" v-if="userType !== 'ProviderUser'">
            <label for="search">Search</label>
            <div class="dataTables_filter" id="filter-search">
              <i class="ic-search"></i>
              <input
                v-model="requestParams.keyword"
                id="search"
                type="search"
                class="form-control"
                placeholder="Search"
              />
            </div>
          </div>
          <div class="col-sm-6" v-if="userType !== 'ProviderUser'">
            <label for="search">Country</label>
            <v-select
              class="v-search-select"
              placeholder="Country"
              label="name"
              v-model="requestParams.country"
              :options="countries"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.iata"
            />
          </div>
          <div
            class="col-sm-4"
            style="margin-top: 20px"
            v-if="userType !== 'ProviderUser'"
          >
            <label for="search">Zone</label>
            <v-select
              class="v-search-select"
              placeholder="Zone"
              label="name"
              v-model="requestParams.zones"
              :options="zones"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.id"
            />
          </div>
          <div
            class="col-sm-4"
            style="margin-top: 20px"
            v-if="userType !== 'ProviderUser'"
          >
            <label>Tag</label>
            <v-select
              class="v-search-select"
              placeholder="Tag"
              label="name"
              v-model="requestParams.tags"
              :options="tags"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.id"
            />
          </div>
          <div
            class="col-sm-4"
            style="margin-top: 20px"
            v-if="userType !== 'ProviderUser'"
          >
            <label>Company</label>
            <v-select
              class="v-search-select"
              placeholder="Company"
              label="name"
              v-model="requestParams.companies"
              :options="companies"
              :clearable="true"
              :searchable="true"
              :filterable="true"
              :reduce="(option) => option.id"
            />
          </div>
          <div
            class="col-sm-5"
            style="margin-top: 25px"
            v-if="userType !== 'ProviderUser'"
          >
            <div class="dataTables_filter">
              <div class="d-flex" style="gap: 10px">
                <button class="search-button" @click="onSearch()">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 20 20"
                  >
                    <g fill="none">
                      <path
                        d="M8.5 3a5.5 5.5 0 0 1 4.383 8.823l4.147 4.147a.75.75 0 0 1-.976 1.133l-.084-.073l-4.147-4.147A5.5 5.5 0 1 1 8.5 3zm0 1.5a4 4 0 1 0 0 8a4 4 0 0 0 0-8z"
                        fill="currentColor"
                      ></path>
                    </g>
                  </svg>
                  Search
                </button>
                <button class="clear-button" @click="resetFilter()">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                  >
                    <path
                      d="M289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34z"
                      fill="currentColor"
                    ></path>
                  </svg>
                  Clear All
                </button>
              </div>
            </div>
          </div>
          <div
            :class="userType !== 'ProviderUser' ? 'col-sm-7' : 'col-sm-12'"
            style="margin-top: 25px"
          >
            <div class="dataTables_length">
              <!-- <label>
                <span>Sort by: </span>
                <select
                  class="form-control v-select"
                  v-model="requestParams.sort"
                  style="width: 250px"
                  @change="(e) => onSelectSort(e.target.value)"
                >
                  <option
                    v-for="item in sortByOption"
                    :value="item.value"
                    :key="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </label> -->
              <label>
                <select
                  class="form-control v-select"
                  v-model="requestParams.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in pageSizeOption"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="number">No</th>
                  <th>Type</th>
                  <th>Zone(s)</th>
                  <th v-if="userType !== 'ProviderUser'">Companies</th>
                  <th>Tag(s)</th>
                  <th class="text-center">Minimum Hire Duration</th>
                  <th class="text-center">Pricing Unit (hours)</th>
                  <th class="text-right">Rate</th>
                  <th class="text-center" v-if="userType !== 'ProviderUser'">
                    Status
                  </th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody v-if="items.length > 0">
                <tr
                  class="detail-row"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td class="td-rate">
                    {{ humanize(item.typeDescription) }}
                  </td>
                  <td class="td-custom">
                    <div class="d-flex items-center justify-between gap-20">
                      <template v-if="item.zones && item.zones.length > 0">
                        <div class="d-flex flex-column">
                          <div
                            class="mb-0 d-flex flex-column"
                            v-for="(zone, idxZone) in item.zones"
                            :key="idxZone"
                          >
                            <span style="display: inline" v-if="idxZone < 2">{{
                              "• " + zone.name
                            }}</span>
                          </div>
                          <button
                            class="btn-see"
                            @click="openModalViewTags(item.zones, 'Zones')"
                            v-if="item.zones.length > 2"
                          >
                            See more ...
                          </button>
                        </div>
                      </template>
                      <template v-else> - </template>
                      <button
                        class="btn btn-default btn-subscribe-provider"
                        v-if="
                          item.subscribers &&
                          item.subscribers.length &&
                          userType === 'TenantUser'
                        "
                        @click="openModalSubscribers(item.subscribers)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 9c-3.15 0-6 2.41-6 6.15c0 2.49 2 5.44 6 8.85c4-3.41 6-6.36 6-8.85C18 11.41 15.15 9 12 9zm0 7.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM12 4c1.93 0 3.68.78 4.95 2.05l-1.41 1.41a5.022 5.022 0 0 0-7.08 0L7.05 6.05A6.976 6.976 0 0 1 12 4zm7.78-.77l-1.41 1.41C16.74 3.01 14.49 2 12.01 2S7.27 3.01 5.64 4.63L4.22 3.22C6.22 1.23 8.97 0 12.01 0s5.78 1.23 7.77 3.23z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  </td>
                  <td
                    class="text-left td-custom"
                    v-if="userType !== 'ProviderUser'"
                  >
                    <template
                      v-if="item.companies && item.companies.length > 0"
                    >
                      <p
                        class="mb-0"
                        v-for="(company, idc) in item.companies"
                        :key="idc"
                      >
                        <span style="display: inline" v-if="idc < 2">{{
                          "• " + company.name
                        }}</span>
                      </p>
                      <button
                        class="btn-see"
                        v-if="item.companies.length > 2"
                        @click="openModalViewCompany(item.companies)"
                      >
                        See more ...
                      </button>
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-left td-custom">
                    <template v-if="item.tags && item.tags.length > 0">
                      <p
                        class="mb-0"
                        v-for="(tag, idt) in item.tags"
                        :key="idt"
                      >
                        <span
                          class="badge badge-tag"
                          :style="`color: ${tag.textColor}; background: ${tag.backgroundColor}`"
                          v-if="idt < 2"
                          >{{ tag.text }}</span
                        >
                      </p>

                      <button
                        class="btn-see"
                        @click="openModalViewTags(item.tags, 'Tags')"
                        v-if="item.tags.length > 2"
                      >
                        See more ...
                      </button>
                    </template>
                    <template v-else> - </template>
                  </td>
                  <td class="text-center td-custom">
                    {{
                      item.minimumHireDuration ? item.minimumHireDuration : "-"
                    }}
                  </td>
                  <td class="text-center td-custom">
                    {{ item.duration }}
                  </td>
                  <td class="text-right td-rate">
                    {{ item.currency }}
                    {{
                      item.rate.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td
                    class="text-center td-rate"
                    v-if="userType !== 'ProviderUser'"
                  >
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        :disabled="!isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div
                      class="button-action-wrapper button-action-wrapper-new"
                      v-if="userType !== 'ProviderUser'"
                    >
                      <button
                        v-if="isAllowToUpdate"
                        class="btn btn-edit"
                        type="button"
                        @click="bindModel(item)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path
                              d="M9 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-3"
                            ></path>
                            <path
                              d="M9 15h3l8.5-8.5a1.5 1.5 0 0 0-3-3L9 12v3"
                            ></path>
                            <path d="M16 5l3 3"></path>
                          </g>
                        </svg>
                      </button>
                      <button
                        v-if="isAllowToDelete"
                        class="btn btn-delete"
                        type="button"
                        @click="confirmDelete(item)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 512 512"
                        >
                          <path
                            d="M400 145.49L366.51 112L256 222.51L145.49 112L112 145.49L222.51 256L112 366.51L145.49 400L256 289.49L366.51 400L400 366.51L289.49 256L400 145.49z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                    <label v-else class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.subscribed"
                        @change="subscription(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle"
                        >{{ item.subscribed ? "Subscribed" : "Subscribe" }}
                      </span>
                    </label>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="10" class="text-center">
                    <span class="svg-empty-box"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 24 24"
                      >
                        <g fill="none">
                          <path
                            d="M12 10c4.418 0 8-1.79 8-4s-3.582-4-8-4s-8 1.79-8 4s3.582 4 8 4zm6.328.17A7.61 7.61 0 0 0 20 9.053v3.204a5.477 5.477 0 0 0-4.02-1.233a11.687 11.687 0 0 0 2.348-.854zM11 16.5a5.502 5.502 0 0 0 3.831 5.242c-.88.167-1.834.258-2.831.258c-4.418 0-8-1.79-8-4V9.053a7.61 7.61 0 0 0 1.672 1.117C7.37 11.018 9.608 11.5 12 11.5c.958 0 1.892-.077 2.777-.225A5.502 5.502 0 0 0 11 16.5zm5.5 4.5a4.48 4.48 0 0 0 2.607-.832l2.613 2.612a.75.75 0 1 0 1.06-1.06l-2.612-2.613A4.5 4.5 0 1 0 16.5 21zm0-1.5a3 3 0 1 1 0-6a3 3 0 0 1 0 6z"
                            fill="currentColor"
                          ></path>
                        </g></svg
                    ></span>
                    <h5 class="label-empty-data">None.</h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div
              class="dataTables_info --blue25"
              style="padding-top: 15px; padding-bottom: 15px"
            >
              <strong>{{ requestParams.totalItems }} Records</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="requestParams.page"
                :page-count="requestParams.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="hourlymodal">
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Hourly</h4>
                <!-- <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6> -->
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="form-group">
                      <label class="required">Rate Type</label>
                      <v-select
                        class="v-search-select"
                        :class="{
                          'field-error': isSubmitted && $v.model.type.$error,
                        }"
                        placeholder=""
                        label="label"
                        v-model="model.type"
                        :options="types"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.text"
                      ></v-select>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.type.required"
                        >Type is required</small
                      >
                    </div>
                    <div class="form-group">
                      <label class="required">Zone(s)</label>
                      <multiselect
                        v-model="model.zones"
                        :class="{
                          'field-error':
                            isSubmitted && !$v.model.zones.required,
                        }"
                        :options="zones"
                        :multiple="true"
                        :close-on-select="false"
                        placeholder="Select group zone(s)"
                        label="label"
                        track-by="id"
                      />
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.zones.required"
                      >
                        Zone(s) is required
                      </small>
                    </div>
                    <div class="form-group">
                      <label class="">Tag(s)</label>
                      <multiselect
                        v-model="model.tags"
                        :options="tags"
                        :multiple="true"
                        :close-on-select="false"
                        placeholder="Select tag(s)"
                        label="text"
                        track-by="id"
                      />
                    </div>
                    <div class="form-group">
                      <div class="d-flex py-2">
                        <label class="">Company</label>
                        <button
                          type="button"
                          class="btn-select-all ml-5"
                          @click="onSelectAll()"
                        >
                          Select All
                        </button>
                        <button
                          type="button"
                          class="btn-clear-all ml-5"
                          @click="onClearAll()"
                          v-if="hasCompanies"
                        >
                          Clear All
                        </button>
                      </div>
                      <multiselect
                        v-model="model.companies"
                        :options="companies"
                        :multiple="true"
                        :close-on-select="false"
                        placeholder="Select Companies"
                        label="name"
                        track-by="id"
                      />
                    </div>
                    <div class="form-group">
                      <label class="required">Minimum Hire Duration</label>
                      <input
                        class="form-control"
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.minimumHireDuration.$error,
                        }"
                        type="number"
                        v-model="model.minimumHireDuration"
                        placeholder="Number"
                      />
                      <div
                        v-if="
                          isSubmitted && $v.model.minimumHireDuration.$error
                        "
                      >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.minimumHireDuration.required"
                          >Minimum Hire Duration is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.minimumHireDuration.minValue"
                          >Minimum Hire Duration is
                          {{
                            $v.model.minimumHireDuration.$params.minValue.min
                          }}</small
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="required">Pricing Unit (hours)</label>
                      <input
                        class="form-control"
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.duration.$error,
                        }"
                        type="number"
                        v-model="model.duration"
                        placeholder="Number"
                      />
                      <div v-if="isSubmitted && $v.model.duration.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.duration.required"
                          >Duration is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.duration.minValue"
                          >Min duration is
                          {{ $v.model.duration.$params.minValue.min }}</small
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="required"> Currency </label>
                      <v-select
                        class="v-search-select"
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.currency.$error,
                        }"
                        placeholder="Select currency"
                        label="text"
                        v-model="model.currency"
                        :options="currencies"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.value"
                      />
                      <div v-if="isSubmitted && $v.model.currency.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.currency.required"
                          >Currency is required</small
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="required"> Rate </label>
                      <currency-input
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.model.rate.$error,
                        }"
                        autocomplete="off"
                        placeholder="Enter rate"
                        v-model="model.rate"
                        :allow-negative="false"
                        :currency="null"
                      />
                      <div v-if="isSubmitted && $v.model.rate.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.rate.required"
                          >Rate is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.rate.minValue"
                          >Min rate is
                          {{ $v.model.rate.$params.minValue.min }}</small
                        >
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="viewcompanymodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-between items-center">
                  <h4>Companies</h4>
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-12">
                <div
                  class="company-box"
                  v-for="company in companySelected"
                  :key="company.id"
                >
                  <div class="building-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 448 512"
                    >
                      <path
                        d="M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                  <span class="company-text">{{ company.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="viewtagsmodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-between items-center">
                  <h4>{{ labelSelected }}</h4>
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="tags-wrapper">
                  <div v-for="(data, index) in dataSelected" :key="index">
                    <div
                      class="tags-item"
                      :style="`color: ${
                        labelSelected.toLowerCase() === 'tags'
                          ? data.textColor
                          : '#fff'
                      }; background: ${
                        labelSelected.toLowerCase() === 'tags'
                          ? data.backgroundColor
                          : '#4fb848'
                      }`"
                    >
                      {{
                        labelSelected.toLowerCase() === "tags"
                          ? data.text
                          : data.name
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="viewsubscribers">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body repricing-modal" id="subscriber-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-between items-center">
                  <h4>Provider Subscribed</h4>
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="tags-wrapper">
                  <div
                    class="subscribers-list-wrapper"
                    v-for="(subs, index) in viewSubscribers"
                    :key="index"
                  >
                    <div class="subscribers-item">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 9c-3.15 0-6 2.41-6 6.15c0 2.49 2 5.44 6 8.85c4-3.41 6-6.36 6-8.85C18 11.41 15.15 9 12 9zm0 7.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM12 4c1.93 0 3.68.78 4.95 2.05l-1.41 1.41a5.022 5.022 0 0 0-7.08 0L7.05 6.05A6.976 6.976 0 0 1 12 4zm7.78-.77l-1.41 1.41C16.74 3.01 14.49 2 12.01 2S7.27 3.01 5.64 4.63L4.22 3.22C6.22 1.23 8.97 0 12.01 0s5.78 1.23 7.77 3.23z"
                          fill="currentColor"
                        ></path>
                      </svg>
                      <span class="subscribers-name">{{ subs.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" @cancel="cancelDelete" />

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import hourlyTariffService from "@/services/master/hourlyTariff/hourlyTariffService.js";
import lookupService from "@/services/shop/lookup/lookupService.js";
import exchangeRateService from "@/services/master/exchangeRate/exchangeRateService.js";
import zoneService from "@/services/master/zone/zoneService.js";
import countryService from "@/services/master/countryService.js";
import companyService from "@/services/master/company/companyService.js";
import taggingService from "@/services/master/rateTag/rateTagService.js";
import deleteModal from "@/components/shared/DeleteModal";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    queryParamsString() {
      const paramsString = Object.entries(this.requestParams)
        .filter(
          ([key, value]) =>
            value !== null && value !== undefined && key !== "totalItems"
        )
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");

      return paramsString.length > 0
        ? `?${paramsString}&classname=${this.$route.query.classname}`
        : "";
    },
    hasCompanies: function () {
      return this.model.companies && this.model.companies.length;
    },
  },
  data() {
    return {
      isSubmitted: false,
      isUpdate: false,
      isLoading: false,
      requestParams: {
        masterClassId: null,
        fareCategory: null,
        country: null,
        zones: null,
        tags: null,
        companies: null,
        keyword: null,
        page: 1,
        pageSize: 10,
        totalPages: 1,
        totalItems: 0,
      },
      rentalLabel: null,
      allPermissions: [],
      items: [],
      msg: "Please wait",
      userType: "Unspecified",
      className: null,
      model: {
        fareCategory: null,
        rate: null,
        currency: null,
        duration: null,
        minHourDuration: null,
        type: null,
        zones: null,
        tags: null,
        companies: null,
      },
      itemToBeDeleted: null,
      currencies: [],
      types: [],
      options: [],
      zones: [],
      tags: [],
      companies: [],
      countries: [],
      pageSizeOption: [10, 25, 50, 100],
      companySelected: [],
      dataSelected: [],
      labelSelected: [],
      fareCategory: null,
      viewSubscribers: [],
    };
  },
  validations() {
    return {
      model: {
        type: { required },
        minimumHireDuration: { required, minValue: minValue(0) },
        duration: { required, minValue: minValue(0) },
        zones: { required },
        currency: { required },
        tags: {},
        companies: {},
        rate: { required, minValue: minValue(0) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");

    this.rentalLabel = this.$helper.extractSetting(
      publicSettings,
      "RentalLabel",
      "Hourly"
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    this.userType = profile.userType;
    this.model.fareCategory = this.$route.path.split("/")[1];
    this.requestParams.fareCategory = this.$route.path.split("/")[1];
    this.requestParams.masterClassId = this.$route.params.masterClassId;
    this.className = this.$route.query.classname;
    this.fareCategory = this.$route.path.split("/")[1];

    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      if (this.userType !== "ProviderUser") {
        await this.getAll();
      } else {
        await this.getListRateProvider();
      }
      await this.getCommon();
      await this.getCurrency();
      await this.getAllZones();
      await this.getCompanies();
      await this.getTags();
      this.countries = await countryService.getAll();
    }
  },
  updated() {
    this.$helper.collapseMenu(`${this.fareCategory}-tariff`);
    this.$helper.setNavigationClass(
      `${this.fareCategory}-rental-chauffeur-link-new`
    );
  },
  methods: {
    async onNavigateCallback(pageNumber) {
      this.requestParams.page = pageNumber;
      this.onSearch();
    },
    onSelectAll() {
      this.model.companies = this.companies;
    },
    onClearAll() {
      this.model.companies = null;
    },
    async onChangePageSize() {
      if (this.userType !== "ProviderUser") {
        this.onSearch();
      } else {
        this.getListRateProvider();
      }
    },
    onSearch() {
      const path = `${this.$route.path}${this.queryParamsString}`;
      if (this.$route.path !== path) this.$router.push(path);
    },
    resetFilter() {
      this.requestParams = {
        ...this.requestParams,
        country: null,
        zones: null,
        tags: null,
        companies: null,
        keyword: null,
      };

      this.$router.replace(
        `${this.$route.path}?classname=${this.$route.query.classname}`
      );
    },
    async getAll() {
      try {
        this.isLoading = true;
        const response = await hourlyTariffService.getListRate(
          this.queryParamsString
        );
        this.items = response.data.items;
        this.requestParams.totalPages = response.data.totalPages;
        this.requestParams.totalItems = response.data.totalItems;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getListRateProvider() {
      this.isLoading = true;
      try {
        const filter = `?masterClassId=${this.requestParams.masterClassId}&page=${this.requestParams.page}&pageSize=${this.requestParams.pageSize}`;
        const response = await hourlyTariffService.getListRateProvider(filter);
        this.items = response.data.items;
        this.requestParams.totalPages = response.data.totalPages;
        this.requestParams.totalItems = response.data.totalItems;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCommon() {
      const common = await lookupService.chauffeurCommon(false);
      this.types = common.data;

      for (let i = 0; i < this.types.length; i++) {
        const item = this.types[i];
        item.label = this.humanize(item.text);
      }
    },
    async getCurrency() {
      const response = await exchangeRateService.getCurrencySelection();
      if (response && Object.keys(response).length > 0) {
        this.currencies = Object.entries(response).map(([key, value]) => ({
          value: key,
          text: value,
        }));
      }
    },
    async getAllZones() {
      this.zones = await zoneService.getAllActive();

      for (let i = 0; i < this.zones.length; i++) {
        const item = this.zones[i];
        item.label = `${item.group} ${item.name}`;
      }
    },
    async getCompanies() {
      try {
        this.companies = await companyService.getAllActive();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async getTags() {
      try {
        this.tags = await taggingService.getAll();
        this.tags = this.tags.map((val) => ({ ...val, text: val.name }));
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    createItem() {
      const data = {
        type: null,
        minimumHireDuration: null,
        duration: null,
        rate: null,
        currency: null,
        zones: null,
        tags: null,
        companies: null,
        fareCategory: this.model.fareCategory,
      };
      this.isUpdate = false;
      this.resetValidations();
      this.model = Object.assign({}, data);
      $(this.$refs.hourlymodal).modal({ backdrop: "static", keyboard: false });
    },
    bindModel(item) {
      const data = {
        masterClassId: item.masterClassId,
        type: item.typeDescription.trim(),
        minimumHireDuration: item.minimumHireDuration,
        duration: item.duration,
        rate: item.rate,
        currency: item.currency,
        zones:
          item.zones.length &&
          item.zones.map((val) => ({ ...val, label: val.name })),
        tags: item.tags,
        companies: item.companies,
        tariffHourlyId: item.tariffHourlyId,
        tariffHourlyRateId: item.tariffHourlyRateId,
        fareCategory: this.model.fareCategory,
      };
      this.isUpdate = true;
      this.resetValidations();
      this.model = Object.assign({}, data);
      $(this.$refs.hourlymodal).modal({ backdrop: "static", keyboard: false });
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        let payload = {
          masterClassId: this.$route.params.masterClassId,
          type: this.model.type.split(" ").join(""),
          minimumHireDuration: Number(this.model.minimumHireDuration),
          duration: Number(this.model.duration),
          rate: Number(this.model.rate),
          currency: this.model.currency,
          zones: this.model.zones.map((val) => val.id),
          tags: this.model.tags && this.model.tags.map((val) => val.id),
          companies:
            this.model.companies && this.model.companies.map((val) => val.id),
        };

        let response;

        if (!this.isUpdate) {
          response = await hourlyTariffService.create(payload);
        } else {
          payload = {
            ...payload,
            tariffHourlyId: this.model.tariffHourlyId,
            tariffHourlyRateId: this.model.tariffHourlyRateId,
            fareCategory: this.model.fareCategory === "buying" ? 1 : 2,
          };
          response = await hourlyTariffService.update(payload);
        }

        if (response.isSuccess) {
          this.$notification.success(
            !isUpdate ? "Successfully created." : "Successfully updated.",
            {
              title: "Success",
            }
          );
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        this.isSubmitted = false;
        this.isUpdate = false;
        this.getAll();
        $(this.$refs.hourlymodal).modal("hide");
      }
    },
    async changeStatus(item) {
      this.isLoading = true;
      try {
        const payload = {
          tariffHourlyId: item.tariffHourlyId,
          tariffHourlyRateId: item.tariffHourlyRateId,
          isActive: item.isActive,
        };
        const response = await hourlyTariffService.activation(payload);

        if (response.isSuccess) {
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        this.getAll();
      }
    },
    async subscription(item) {
      this.isLoading = true;
      try {
        const payload = {
          tariffHourlyId: item.tariffHourlyId,
          subscribed: item.subscribed,
        };
        const response = await hourlyTariffService.subscription(payload);

        if (response.isSuccess) {
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        this.getListRateProvider();
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    cancelDelete() {
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
    async submitDelete() {
      this.isLoading = true;
      try {
        const payload = {
          fareCategory: this.model.fareCategory,
          tariffHourlyId: this.itemToBeDeleted.tariffHourlyId,
        };

        const response = await hourlyTariffService.delete(payload);

        if (response.isSuccess) {
          this.$notification.success("Successfully deleted.", {
            title: "Success",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        this.getAll();
      }
    },
    openModalViewCompany(companies) {
      this.companySelected = companies;
      $(this.$refs.viewcompanymodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    openModalViewTags(data, label) {
      this.dataSelected = data;
      this.labelSelected = label;
      $(this.$refs.viewtagsmodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    openModalSubscribers(data) {
      this.viewSubscribers = data;
      $(this.$refs.viewsubscribers).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
  },
  watch: {
    "$route.params": {
      deep: true,
      handler: function (value) {
        if (this.userType !== "ProviderUser") {
          this.getAll();
        } else {
          this.getListRateProvider();
        }
      },
    },
  },
};
</script>
<style scoped>
.td-custom {
  min-width: 180px !important;
  width: auto;
}

.td-rate {
  min-width: 130px !important;
  width: auto;
}

.btn-see {
  color: #5499e4;
  margin-top: 5px;
  padding: 3px 4px;
  border: none;
  border-radius: 5px;
  background: transparent;
}

.btn-see:hover {
  background: #efefef;
}

span.svg-empty-box svg {
  width: 80px;
  color: #363636;
}

h5.label-empty-data {
  font-weight: 800;
  color: #363633;
}

#subscriber-modal h4 {
  font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/master/hourlyTariff/HourlyChauffeurRate.vue